<template>

<div  style="margin-top:0px">

 
  <div class="table-wrapper-scroll-y my-custom-scrollbar">
    
    <table class="table table-sm table-hover">
    <thead>
    <tr class="table-primary">
      <th scope="col">DATA</th>
      <th scope="col">ORA</th>
      <th scope="col">SEDE</th>
      <th class="text-right" scope="col">TOT. VENDUTO</th>
      <th class="text-right" scope="col">PAGATO</th>
      <th>STAMPA RICEVUTA</th>
      <th>STAMPA SCONTRINO  </th>
      
    </tr>
    </thead>
    <tbody>
      <tr   data-toggle="tooltip" class="pointer"  v-for="(item, index) in items" :key="index">
        <td>{{item.create_at}}</td>
        <td>{{item.hour_at}}</td>
        <td>{{item.store}}</td>
        <td  v-bind:style="{ color : item.total-item.discount  < 0 ?  'red' : ''}" class="text-right">{{fmt1(item.total-item.discount)}}</td>
        <td class="text-right"><span style="font-size:18px" class="badge" v-bind:class="{'badge-success' : item.row_type == 1}" >{{fmt1(item.paid)}}</span></td>
        <td class="text-right_">
          <button v-if="item.row_type==1" class="btn btn-sm btn-light" @click="print(item)">
            <i v-if="item.row_type==1" @click="print(item)" style='color:red;' data-toggle="tooltip" title="stampa ricevuta"  class="fas fa-file-pdf mr-2" aria-hidden="true"></i>
            STAMPA 
          </button>
        </td>
        <td class="text-right_">
          <button :disabled="company.Id != 48" v-if="item.row_type==1" class="btn btn-sm btn-light" @click="getEpsonNotFiscal(item.saleId,item.paid)">
            <i v-if="item.row_type==1"  style='color:red_;'  class="fas fa-print mr-2" aria-hidden="true"></i>
            STAMPA </button>
          
        </td>
        
      </tr> 
      </tbody>
    </table>
    
  </div>            
 



</div>
</template>
<script>
import api               from '@/api'
import axios             from "axios"
import { mapGetters }    from 'vuex'
import fmt               from '@/components/mixins/fmt'
//import jsPDF             from 'jspdf';


export default {
  mixins     : [fmt],
  props : ['customerId'],
  components: {},
  data() {
    return {
     
      
      items                  : [],
      spinner                : false,
      msg                    : {
        title : '',
        body  : '',
        type  : 0
      },
      
      pdf                    : ''
      
      
     
    };
  },
  computed :{
   
   ...mapGetters(['company']) 
   
  },
  directives: {
    
    focus: {

      inserted : function(el) 
      {
      
        //el.focus();

      }
    }
  },
  mounted: function() 
  {
    
    
  },
  created: function() 
  {
    this.getData()
    
  },
  methods: 
  {
    

    async getEpsonNotFiscal(saleId,total)
    {
      
      const payments = await this.getSalePayments(saleId) 
      if(payments.length==0)
      {
        return
      }
      const crlf         =  '\r\n'  
      const maxLength    = 46  
      const totalLength  = this.fmt1(total).length
      const spc          = ' '
      const description1 = 'INCASSO '
      const description2 = 'TOTALE EURO '
      const description3 = 'euro'
      const description4 = 'Pagamento '
      let txtFile        = 'printerNonFiscal' + crlf
      txtFile += 'beginNonFiscal|1|' + crlf
      txtFile += 'printNormal|1|1|' + spc.repeat(maxLength - description3.length)  + 'euro' + crlf
      txtFile += 'printNormal|1|1|' + description1 + spc.repeat(maxLength - description1.length -  totalLength)  +  this.fmt1(total) +  crlf     
      txtFile += 'printNormal|1|1|' + crlf
      
      txtFile += 'printNormal|1|3|' + description2 + spc.repeat(maxLength - description2.length - totalLength) + this.fmt1(total) + crlf
      payments.forEach(item => {
        const len1 = description4.length
        const len2 = item.typeId.length
        const len3 = this.fmt1(item.amount).length
        
        txtFile += 'printNormal|1|2|' + description4 + item.typeId + spc.repeat(maxLength - len1 - len2 - len3) + this.fmt1(item.amount) + crlf
      });
      // txtFile += 'printBarCode|1|901|3|120|BELOW|FontA|EAN13|' + coupon.barcode + crlf
      txtFile += 'endNonFiscal|1|' + crlf
      this.downLoadFile(txtFile)

     
    },
    downLoadFile(file)
     {
      const data  =  "data:text/csv;charset=utf-8," + file
                        
                var encodedUri = encodeURI(data)
                var link = document.createElement("a")
                link.setAttribute("href", encodedUri)
                link.setAttribute("download", "sco.txt")
                link.click()    
     },
    

 
    print(item)
    {

        var url       = process.env.VUE_APP_ROOT_API + "api/document/create/customer_payment_receipt" 


        axios({
        url     : url,
        method  : "post",
        data    : item,
        
      })
        .then(res => {
          this.pdf   =  process.env.VUE_APP_ROOT_API + 'api/pdf/' +  res.data
          
          this.$emit('openPDF',this.pdf)
          //console.log(this.pdf)

        })
        .catch(err => {})
        .finally(() => {

          this.spinner = false
           
        });
    


    },

    


    async getData()
    {
      const sp   = {'sp'             : 'spCustomerSales'}
      const data = {'customerId'     : this.customerId}

      const json  = Object.assign(data, sp)
      
      await api.post(json).then(res => {
	      if(res.status==200)
        {
          this.items = res.data.recordsets[0]         
        }
          else if(res.status==500)
        {
    	    console.log(res.data)

        } 
        else
        {
    	    console.log('Network Error.')                  
        } 
        }).catch(err => 
        {
	        console.log(err.message)    
        }).finally(() => {
	        
        });


     

    },

    async getSalePayments(saleId)
    {
      const sp   = {'sp'         : 'spSalePayments'}
      const data = {'saleId'     : saleId}
      const json  = Object.assign(data, sp)
      return new Promise( async (resolve, reject)   =>  {
      await api.post(json).then(res => {
	      if(res.status==200)
        {
          resolve(res.data.recordsets[0])
          
        }
          else if(res.status==500)
        {
    	    resolve([])
          console.log(res.data)

        } 
        else
        {
          resolve([])
    	    console.log('Network Error.')                  
        } 
        }).catch(err => 
        {
          resolve([])
	        console.log(err.message)    
        }).finally(() => {
	        
        });

      })
     

    },

    
  

  
}

}
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 400px;
overflow: auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}
.table-wrapper-scroll-y {
display: block;
}


h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}



 .table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 .table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}
</style>